import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function withRedirectTo(WrappedComponent, predicateForRedirect, url = '/404') {
  return class RedirectTo extends Component {
    render() {
      if (typeof predicateForRedirect !== 'function') {
        return <WrappedComponent {...this.props} />;
      }
      if (predicateForRedirect(this.props)) {
        return <Redirect push to={url} />;
      }

      return <WrappedComponent {...this.props} />;
    }

    static propTypes = {
      match: PropTypes.object
    };
  };
}

export default withRedirectTo;
